import { createRouter, createWebHashHistory } from "vue-router";
import routes from "./routes";

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes,
});

// 全局路由守卫
router.beforeEach((to, from, next) => {
  const userToken = localStorage.getItem("usertoken");

  // 如果用户已授权但要访问auth页面，直接跳转到首页
  if (to.name === "Auth" && userToken) {
    // 已授权但有 redirect，就直接回 redirect
    if (to.query.redirect) {
      next(decodeURIComponent(to.query.redirect));
    } else {
      next({ name: "Home" });
    }
    return;
  }

  // 判断是否需要鉴权
  if (to.meta.requiresAuth && !userToken) {
    next({
      name: "Auth",
      query: { redirect: to.fullPath }, // 带上当前完整路径
    });
    return;
  }

  next();
});
export default router;
